import { createAction, props } from '@ngrx/store';

import { Production } from '../../models/production.model';

export const loadProductionListRequest = createAction('[Production] Load production list');

export const loadProductionListSuccess = createAction(
  '[Production] Load production list succeeded',
  props<{ productionList: Production[] }>(),
);

export const setSelectedProduction = createAction(
  '[Production] set selected Production',
  props<{ production: Production }>(),
);
